import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import Grid from '@material-ui/core/Grid';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';


function CopyPopover({ classes, data, setData }) {
    return (
        <Popover
            id="copyPopover"
            open={Boolean(data)}
            anchorEl={data?.anchor}
            onClose={() => setData(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Grid container spacing={0} alignItems="center" className={classes.popover}>
                <Grid item xs>
                    <Typography id="copyData" className={classes.popoverText} >{data?.data}</Typography>
                </Grid>
                <Grid item>
                    <Button	edge="end" onClick={data?.onClick}>
                        <FileCopyIcon />
                    </Button>
                </Grid>
            </Grid>
        </Popover>
    );
}

CopyPopover.propTypes = {
	classes: PropTypes.object.isRequired,
	data: PropTypes.object,
	setData: PropTypes.func.isRequired
}

export default withStyles(styles)(CopyPopover);